module.exports = __webpack_public_path__ + "static/the-sovereign-individual-aadb1dd6f3d91b65e78c87d11ddc9ef6.jpg";